import { render, staticRenderFns } from "./BlockButton.vue?vue&type=template&id=6000c352"
import script from "./BlockButton.vue?vue&type=script&lang=ts"
export * from "./BlockButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports